import Vue from 'vue'
import Vuex from 'vuex'
import QType from './QType'
import DType from './DType'
import axios from 'axios'

// 讀取 iis 設置
const zhConfig = require('../../zh.config')
const isIISSubApp = zhConfig.isIISSubApp
const developPort = zhConfig.developPort
const IISSubAppRoute = zhConfig.IISSubAppRoute

// 環境為 dev 或 production
const isDev = !(process.env.NODE_ENV === 'production')

// 伺服器路徑
const server = isDev
  ? 'https://localhost:' + developPort + '/'
  : window.location.href
      .split('/')
      // set root path according to isIISSubApp
      .slice(0, 3)
      .join('/') +
    '/' +
    IISSubAppRoute +
    '/'

// 計算圖片根目錄
const imgRoot = (isDev ? '/' : server + 'admin/') + 'img/'
// 使用者圖片
const user_holder_img = imgRoot + 'user_holder.jpg'
// logo 位址
const logo = imgRoot + 'logo.png'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    charts:[], //匯出表格使用    
    zhConfig,
    api: server + 'admin/api',
    // api: '/admin/api', //因為使用proxy
    server,
    loginServerEnterprise: null,
    loginServer: null,
    logo,
    user: {
      name: '展輝科技',
      img: user_holder_img,
      userToken: null,
      clientUserType: '',
      isLogin: false
    },
    // 設定中的問卷題目
    ques: {
      key: 0, // 紀錄 ques 因加入、查詢而不斷獲得遞增的 key (用於 v-for) 當前值
      list: []
    },
    date: {
      current: '',
      nextMonth: '',
      lastMonth: ''
    },
    QType,
    DType,
    menus: {}, // menu tree
    menusId: [],
    useHistory: [],
    quesData: [],
    questDetailHeaders: [],
    questDetailResults: [],
    chartQuestD: [],
    chartQuestResult: [],
    groups: [],
    users: [],
    operLog: [],
    menuTree: [],
    clientMember: [],
    parentMenu: [],
    questCmb: [],
    userType: [],
    pageType: [],
    useStatus: [],
    userGroup: [],
    userCmb: [],
    vuetify: {
      theme: {
        themes: {
          light: {
            primary: '#f0aa00'
            // 底色 FFF8E1
          }
        }
      }
    }
  },
  mutations: {
    quesSet(state, payload) {
      state.ques.list[payload.idx][payload.key] = payload.value
    },
    quesDel(state, idx) {
      state.ques.list.splice(idx, 1)
      this.commit('quesCalculateSerial') // 重新分配 serial
    },
    // 重新分配 serial
    quesCalculateSerial(state) {
      state.ques.list.forEach((q, idx) => {
        q.serial = idx + 1
      })
    },
    getDate(state) {
      var currentdate = new Date()
      let monthCurrent = currentdate.getMonth() + 1
      let monthNext = monthCurrent == 12 ? 1 : monthCurrent + 1
      let monthLast = monthCurrent == 1 ? 12 : monthCurrent - 1
      let yearCurrent = currentdate.getFullYear()
      let yearNext = monthCurrent == 12 ? yearCurrent + 1 : yearCurrent
      let yearLast = monthCurrent == 1 ? yearCurrent - 1 : yearCurrent
      let dayStr = ('0' + currentdate.getDate()).slice(-2)

      state.date.current =
        yearCurrent + '-' + ('0' + monthCurrent).slice(-2) + '-' + dayStr
      state.date.nextMonth = yearNext + '-' + ('0' + monthNext).slice(-2) + '-' + dayStr
      state.date.lastMonth = yearLast + '-' + ('0' + monthLast).slice(-2) + '-' + dayStr
    }
  },
  actions: {
    async getMenuTree() {
      window.console.log('start to get mentTree')
      await axios
        .get(this.state.api + '/Admin/GetMenuTree')
        .then(res => {
          window.console.log(res.data)
          if (res.data.resultCode !== '10') {
            let err = '取得目錄樹時發生錯誤，詳細資料：' + res.data.error
            window.console.log(err)
            throw new Error(err)
          }
          window.console.log(res.data)

          this.state.ques.assignCheck = res.data.assignCheck
          this.state.ques.inputCheck = [
            { inputCheck: null, inputCheckName: '不檢查' },
            ...res.data.inputCheck
          ]

          this.state.useStatus = res.data.useStatus
          this.state.userGroup = res.data.userGroup
          this.state.publicType = [
            { value: null, name: '請選擇問卷公開狀態' },
            ...res.data.publicType
          ]
          this.state.pageType = [{ value: null, name: '請選擇' }, ...res.data.pageType]
          this.state.userType = [
            { value: null, name: '請選擇填寫對象' },
            ...res.data.userType
          ]
          this.state.childrenMenu = [
            { value: null, name: '請選擇' },
            ...res.data.childrenMenu
          ]
          this.state.userCmb = [{ value: null, name: '請選擇' }, ...res.data.userCmb]
          this.state.groupCmb = [{ value: null, name: '請選擇' }, ...res.data.groupCmb]
          this.state.questCmb = [
            { value: null, name: '請選擇查詢類型', placeholder: '請先選擇查詢類型' },
            ...res.data.questCmb
          ]
          let menus = res.data.menus
          // 堆疊允許存取的 menusId
          let keyArr = Object.keys(menus)
          let menusId = Object.keys(menus)
          for (const key of keyArr) {
            let children = menus[key].children
            if (children) {
              let addKeys = Object.keys(children)
              menusId = menusId.concat(addKeys)
            }
          }

          // 將 menus, menusId 存入 store
          this.state.menus = menus
          this.state.menusId = menusId
          window.console.log(menusId)
        })
        .catch(err => {
          this.state.user.isLogin = false
        })
    },
    // 回傳遞增的數字做為 ques 進行 v-for 時的 key
    QuesKeysAdd() {
      this.state.ques.key += 1
      return this.state.ques.key
    }
  },
  modules: {}
})
